import { apiClient } from "./client";

export interface MeetingListRequest {
  pageNumber: number;
  pageSize: number;
  search?: string;
  aiAgentIds?: string[];
  filter?: {
    dateRangeType?: "dateRange" | "lastxdays";
    startDate?: string;
    endDate?: string;
    day?: number;
  };
}

export interface Meeting {
  meetingId?: number;
  meetingUID?: string;
  subject?: string;
  description?: string;
  allTime?: boolean;
  startTime?: string;
  endTime?: string;
  rrule?: string | null;
  attendees?: {
    lead?: Array<{
      name?: string;
      email?: string;
    }>;
  };
  externalAttendees?: string;
  leadId?: number;
  googleEventId?: string;
  googleMeetLink?: string;
  isCreatedByAiAgent?: boolean;
  aiAgentId?: string;
  aiAgentData?: {
    id?: number;
    type?: string;
    uuid?: string;
    display_name?: string;
  };
  tenantId?: number;
  createdAt?: string;
  updatedAt?: string | null;
  deletedAt?: string | null;
  createdById?: number;
  updatedById?: number | null;
  deletedById?: number | null;
  meetingDate?: string;
  lead?: Record<string, unknown>;
  [key: string]: unknown;
}

class MeetingsService {
  private readonly basePath = "/clients/meetings";

  async listing(params: MeetingListRequest): Promise<any> {
    return apiClient.post(`${this.basePath}/listing`, params);
  }
}

export const meetingsService = new MeetingsService();
